import React, { ReactElement } from 'react'
import { Text, Box } from '@chakra-ui/react'
import { SpringValue } from 'react-spring'

import { AnimatedHStack } from '@/lib/springComponent'

import { ReactComponent as CheckIcon } from '@/svg/check.svg'

interface Props {
  fillColor: string
  strokeColor: string
  label: string
  style?: Record<string, SpringValue>
}

function CheckListItem({
  fillColor,
  strokeColor,
  label,
  style,
}: Props): ReactElement {
  return (
    <AnimatedHStack
      spacing="7"
      style={style}
      sx={{
        '& svg': {
          flex: '0 0 auto',
        },
        '& svg > circle': {
          fill: fillColor,
        },
        '& svg > path': {
          stroke: strokeColor,
          strokeWidth: 2,
        },
        alignItems: 'flex-start',
      }}
    >
      <CheckIcon />
      <Box>
        <Text
          sx={{
            fontSize: {
              base: 'lg',
              md: 'xl',
            },
            marginTop: {
              base: 2,
              'lg+': '6px',
            },
            fontWeight: 'medium',
          }}
        >
          {label}
        </Text>
      </Box>
    </AnimatedHStack>
  )
}

CheckListItem.defaultProps = {}

export default CheckListItem
